import { type PartialDeep } from 'type-fest';

import { type PropertiesConfigInputVisualEffectModel } from '@blaze-shared/elements-domain';

import { PropsExtractor } from '../__base/props-extractor';

export class FormGroupPropsExtractor extends PropsExtractor<'formGroup'> {
  override getVisualEffect: () => PartialDeep<PropertiesConfigInputVisualEffectModel> | undefined =
    () => this.props?.style?.general?.visualEffect;
}
